import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'underscore';

class MalidCard extends Component {
	constructor(props) {
		super(props);

		this.expandButtonClickHandler = this.expandButtonClickHandler.bind(this);

		let minimizedDatasets = localStorage.getItem('malid_minimized_datasets') ? JSON.parse(localStorage.getItem('malid_minimized_datasets')) : [];

		this.state = {
			initialized: false,
			minimized: minimizedDatasets.indexOf(this.props.database) > -1,
			showInfo: false
		}
	}

	expandButtonClickHandler() {
		this.setState({
			minimized: !this.state.minimized
		}, function() {
			let minimizedDatasets = localStorage.getItem('malid_minimized_datasets') ? JSON.parse(localStorage.getItem('malid_minimized_datasets')) : [];

			if (this.state.minimized) {
				minimizedDatasets.push(this.props.database);
			}
			else {
				minimizedDatasets = _.without(minimizedDatasets, this.props.database);
			}

			localStorage.setItem('malid_minimized_datasets', JSON.stringify(_.uniq(minimizedDatasets)));
		}.bind(this));
	}

	componentDidMount() {
		setTimeout(function() {
			this.setState({
				initialized: true
			});
		}.bind(this), 100);
	}

	componentDidUpdate(prevProps) {
		if (this.props.children != prevProps.children) {
			this.setState({
				showInfo: false
			})
		}
	}

	render() {
		return (
			<div className={'card'+(this.props.database ? ' database-'+this.props.database : '')+(this.props.className ? ' '+this.props.className : '')+(this.state.initialized ? ' initialized' : '')+(this.state.minimized ? ' minimized' : '')+((!this.props.visible && !this.props.frontPage) || this.props.forceHidden ? ' hidden' : '')}
				style={{
					transitionDelay: (this.props.count/10)+'s'
				}}
			>
				<div className={'card-header'+((!this.props.visible && !this.props.frontPage) ? ' hidden' : '')}
					style={this.state.minimized ? { cursor: 'pointer'} : null} onClick={() => {
						if (this.state.minimized) {
							this.expandButtonClickHandler();
						}
					}}>
					{this.props.title}
					{
						this.props.subTitle && <div className="subtitle">{this.props.subTitle}</div>
					}
					{
						!this.props.frontPage &&
						<button className="info-button" onClick={() => this.setState({
							showInfo: !this.state.showInfo
						})} />
					}
				</div>

				<div className="card-body">
					{
						(this.state.showInfo || this.props.frontPage) &&
						<p className={'card-text'+(!this.props.frontPage ? ' card-info' : '')} dangerouslySetInnerHTML={{__html: this.props.aboutText}} />
					}
					{
						this.state.showInfo && <hr/>
					}
					{
						!this.props.frontPage && !this.props.showInfo &&
						this.props.children
					}
				</div>

				<button className="expand-button" onClick={this.expandButtonClickHandler}>
					<span className="label">{this.state.minimized ? window.l('database_display_in_results') : window.l('database_hide_in_results')}</span>
					<span className="icon" />
				</button>
			</div>
		);
	}
}

export default MalidCard;



// WEBPACK FOOTER //
// ./src/components/MalidCard.js